(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');

    module.factory('QuickSidebarTasksService', ['TaskService', '$rootScope', '$document', 'TaskStateEnum', 'SharedAgendaService', 'SharedAgendaBroadcast', 'RoleType', 'WebsocketService', 'WebsocketRegisterType', 'Daytask', QuickSidebarTasksServiceFn]);

    // main service for handling tasks in quick-sidebar
    function QuickSidebarTasksServiceFn(TaskService, $rootScope, $document, TaskStateEnum, SharedAgendaService, DayTaskBroadcast, RoleType, WebsocketService, WebsocketRegisterType, Daytask) {

        // ws subscriber
        var ws1, ws2, ws3;

        // data of service
        var data = {
            // list of daytasks
            tasks: [],
            // filtered list of daytasks
            filtered: [],
            // filter value
            filterValue: '',
            // current selected task
            current: null,
            myTasksClicked: !currentUserIsRingphoneAdmin(),
            movesClicked: false,
            adminClicked: false,
            autoRefreshTasksIsDisabled: false,
            importantClicked: false
        };

        // service
        var service = {
            registerWebsocket: registerWebsocket,
            getAll: getAll,
            findById: findById,
            filter: filter,
            reset: reset,
            toggleMyTasksText: toggleMyTasksText,
            toggleFilterAdmins: toggleFilterAdmins,
            toggleFilterMoves: toggleFilterMoves,
            toggleFilterImportant: toggleFilterImportant,
            setTasksDivHeightForScrollBar: setTasksDivHeightForScrollBar,
            data: data,
            Broadcast: {
                AutoRefreshToggleChanged: "auto.refresh.toggle:changed"
            },
        };

        return service

        // register websocket call
        function registerWebsocket() {

            // unregister
            if (ws1) {
                WebsocketService.unregister(ws1.id);
            }
            if (ws2) {
                WebsocketService.unregister(ws2.id);
            }
            if (ws3) {
                WebsocketService.unregister(ws3.id);
            }

            // listen on changes from tasks to update their daytask-list in quick-sidebar set

            if (!data.autoRefreshTasksIsDisabled) {
                // new task is added
                ws1 = WebsocketService.register(WebsocketRegisterType.RingfoonDaytaskAdd, function (jObject) {
                    // add action
                    onAdd(parse(jObject));
                });
            }

            // existing ones deleted
            ws2 = WebsocketService.register(WebsocketRegisterType.RingfoonDaytaskDelete, function (jObject) {
                // delete action
                onDelete(parse(jObject));
            });

            // existing one changed 
            ws3 = WebsocketService.register(WebsocketRegisterType.RingfoonDaytaskUpdate, function (jObject) {
                // update action
                onUpdate(parse(jObject));
            });


        } // registerWebsocket        

        // parse json object
        function parse(jObject) {
            var task = new Daytask();
            //task.extend(JSON.parse(jObject.data));
            task.extend(jObject.data);
            return task;
        }

        function toggleFilterAdmins() {
            data.adminClicked = !data.adminClicked;
            filter();
        }

        function toggleFilterMoves() {
            data.movesClicked = !data.movesClicked;
            filter();
        }

        function toggleMyTasksText() {
            data.myTasksClicked = !data.myTasksClicked;
            filter();
        }

        function toggleFilterImportant(){
            data.importantClicked = !data.importantClicked;
            filter();
        }

        // get the tasks from service
        function getAll() {

            //   data.filtered = [];
            // load daytasks
            return TaskService.tasks().then(function (result) {
                data.tasks = [];
                // make objects 
                var i = 0;
                var len = result.length;
                for (i; i < len; i++) {
                    var dt = new Daytask();
                    dt.extend(result[i]);
                    data.tasks.push(dt);
                } // for

                result = null;
                // set filtered tasks during initial load
                filter(true);
            });
        } // getAll

        function currentUserIsRingphoneAdmin() {
            return $rootScope.isRingfoonOperatorAdmin
                || $rootScope.isRingfoonAdmin;
        }

        // filter the daytask-list
        function filter(startup = false) {
            setTasksDivHeightForScrollBar();
            // clear
            data.filtered = [];
            let value = data.filterValue.toLowerCase();

            // if admin operator show all tasks during startup else a possible filter is active

            if (startup && currentUserIsRingphoneAdmin()) {
                data.filtered = data.tasks;
            } else {
                // filter de daytasks
                // by default we show all tasks
                let i = 0;
                let len = data.tasks.length;
                let firstNameOfCurrentUser = SharedAgendaService.getLoggedInUserData().firstName.trim().toLowerCase();
                let lastNameOfCurrentUser = SharedAgendaService.getLoggedInUserData().lastName.trim().toLowerCase();
                // go over the tas
                for (i; i < len; i++) {
                    let showTask = true;

                    // if user clicked myTasks or mytasks is activated (example not admin operators have this default set on startup)
                    if (data.myTasksClicked) {
                        // hide tasks where name of user is not in agenda name or in the content of daytasks
                        // reactions filtering

                        let foundInReaction = reactionsContainName(data.tasks[i].reactions, firstNameOfCurrentUser, lastNameOfCurrentUser);
                        let foundInAgendaName = textContainsName(data.tasks[i].agendaCaption, firstNameOfCurrentUser, lastNameOfCurrentUser);

                        // if not found in both we hide the task
                        if (!foundInReaction && !foundInAgendaName) {
                            showTask = false;
                        }

                        // ATTENTION: show ALWAYS ALSO tasks of a RINGPHONE agenda if it has a flag assigned (good, info, warning) NO MOVE
                        // Even if onlymytasks is activated
                        if (data.tasks[i].agendaCaption
                            && data.tasks[i].agendaCaption.toLowerCase().indexOf("ringphone") !== -1
                            && data.tasks[i].taskFlag && data.tasks[i].taskFlag.name !== "Move"
                            && data.tasks[i].taskState !== 3) {
                            showTask = true;
                        }
                    }

                    // if move clicked we only show moves
                    if (data.movesClicked) {
                        // hide if flag is not move
                        if (!data.tasks[i].taskFlag || data.tasks[i].taskFlag.name !== "Move") {
                            showTask = false;
                        }
                    }
                    // if admin clicked we only show admin tasks
                    if (data.adminClicked) {
                        // hide if task state is not admin
                        if (data.tasks[i].taskState !== 3) {
                            showTask = false;
                        }
                    }
                    
                    // if the task is marked as important we only show the important tasks
                    if(data.importantClicked){
                        //hide if task is not marked important
                        if(!data.tasks[i].isImportant) {
                            showTask = false;
                        }
                    }

                    // at last we also filter the task on the filled in filter value
                    if (value.length > 0 && showTask) {
                        let foundInNameOrContactDetailsOfPatient = false;
                        let patientDto = data.tasks[i].patientDto;
                        if (patientDto) {
                            let patientInfo = patientDto.birthday + " " + patientDto.caption + " " + patientDto.mainEmail + " " + patientDto.mainMobileValue + " " + patientDto.mainPhoneValue;
                            foundInNameOrContactDetailsOfPatient = textContains(patientInfo, value);
                        }

                        // filtered text is found in reaction
                        let foundInReaction = reactionsContainText(data.tasks[i].reactions, value);
                        
                        // filtered text is found in name of agenda of task
                        let foundInAgendaName = textContains(data.tasks[i].agendaCaption, value);

                        // if not found in both we hide the task
                        if (!foundInReaction && !foundInAgendaName && !foundInNameOrContactDetailsOfPatient) {
                            showTask = false;
                        }
                    }

                    if (showTask) {
                        data.filtered.push(data.tasks[i]);
                    }

                } // for
            }

            $rootScope.filteredDayTaskBadgeCount = data.filtered.length
            $rootScope.$broadcast(DayTaskBroadcast.DayTasksFiltered);
            value = null;
        } // filter
        
        function reactionsContainName(reactions, firstName, lastName) {
            let j = 0;
            for (j; j < reactions.length; j++) {
                let reaction = reactions[j];
                if (textContains(reaction.userFirstName, firstName) && textContains(reaction.userLastName, lastName)) {
                    return true;
                }
                
                if (textContainsName(reaction.content, firstName, lastName)) {
                    return true;
                }
            }
            return false;
        }
        
        function reactionsContainText(reactions, text) {
            let g = 0;
            for (g; g < reactions.length; g++) {
                let reaction = reactions[g];
                if (textContains(reaction.content, text)) {
                    return true;
                }
                if (textContains(reaction.date, text)) {
                    return true;
                }
                if (textContains(reaction.userCaption, text)) {
                    return true;
                }
            }
            return false;
        }
        
        function textContainsName(text, firstName, lastName) {
            if (text) {
                let textLowered = text.toLowerCase();
                return (textLowered.indexOf(firstName) !== -1) && (textLowered.indexOf(lastName) !== -1);
            }
            return false;
        }
        
        function textContains(text, other) {
            if (text) {
                let textLowered = text.toLowerCase();
                let otherLowered = other.toLowerCase();
                
                let textWords = textLowered.split(/\s+/);
                let otherWords = otherLowered.split(/\s+/);

                for (let otherWord of otherWords) {
                    let found = false;
                    for (let i = 0; i < textWords.length; i++) {
                        if (textWords[i].indexOf(otherWord) !== -1) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) return false; 
                }
                return true; 
            }
            return false;
        }

        function setTasksDivHeightForScrollBar(){
            let tasksDiv = $document.find("#tasks");
            let tasksHeaderDivHeight = 75.64+39.16;
            let filtervalueHeight = (data.filterValue.length > 0 || data.adminClicked || data.movesClicked || data.myTasksClicked) ? 34 : 0;            

            tasksDiv.height(window.innerHeight-tasksHeaderDivHeight-5-filtervalueHeight);
        }

        // remove filter value
        function reset() {
            // reset 
            data.filterValue = "";
            data.myTasksClicked = false;
            data.movesClicked = false;
            data.adminClicked = false;
            filter(); // resetting
        }


        // action on add
        function onAdd(task) {
            if (data.autoRefreshTasksIsDisabled) {
                addIfAutoRefreshIsDisabledAndNotForRingphone()
            } else {
                add(task);
            }
            // filter
            filter();
        } // onAdd

        // action on daytask-update from ringfoon
        function onUpdate(task) {

            // remove
            var removedTask = remove(task);

            if (data.autoRefreshTasksIsDisabled) {
                addIfAutoRefreshIsDisabledAndNotForRingphone()
            } else {
                add(task);
            }

            // filter
            filter();
        } // onUpdate

        // action on delete
        function onDelete(task) {
            // delete 
            remove(task);
            // filter
            filter();
        } // onDelete

        // find by id and return index
        function find(task) {
            var index = -1;
            // find task and remove it from list
            var i = 0;
            var len = data.tasks.length;
            for (i; i < len; i++) {
                if (data.tasks[i].id === task.id) {
                    //found 
                    index = i;
                    break;
                } // if
            } // for
            return index;
        } // find

        // find by id
        function findById(id) {
            var i = 0;
            var len = data.tasks.length;
            for (i; i < len; i++) {
                if (data.tasks[i].id === id) {
                    return data.tasks[i];
                }
            } // for
            return null;
        } // findById


        // delete task
        function remove(task) {
            var index = find(task);
            var removedTask = null;
            if (index !== -1) {
                // remove current one
                removedTask = data.tasks.splice(index, 1);
            }  //if
            return removedTask !== null ? removedTask[0] : removedTask;
        } // delete

        function addIfAutoRefreshIsDisabledAndNotForRingphone() {
            // only add tasks if auto refresh is not disabled and task was changed to a NOT Ringphone state
            if (!TaskStateEnum.FollowUpByRingfoon && !TaskStateEnum.FollowUpByOperator) {
                add(task);
            }
        }

        // add task
        function add(task) {
            // add to list
            data.tasks.unshift(task);
        } // add

    }
})();